import { useState, useEffect, useRef } from "react";
import { FaHome, FaSearch, FaCompass, FaArrowRight, FaBrain } from "react-icons/fa";
import logo from "../../assets/QquzyNew.png";

const quickLinks = [
  { label: "My Dashboard", path: "/dashboard" },
  { label: "Browse Quizzes", path: "/quizzes" },
  { label: "Leaderboard", path: "/leaderboard" },
  { label: "Help & Support", path: "/support" },
];

const FloatingDot = ({ style }) => (
  <span
    className="absolute rounded-full bg-indigo-400 opacity-20 animate-pulse"
    style={style}
  />
);

export default function NotFound() {
  const [searchValue, setSearchValue] = useState("");
  const [hasMounted, setHasMounted] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    // Trigger mount animations
    const t = setTimeout(() => setHasMounted(true), 50);
    return () => clearTimeout(t);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchValue.trim()) {
      // In a real app: navigate to search results
      console.log("Searching for:", searchValue);
    }
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-b from-white to-gray-50 flex flex-col items-center justify-center overflow-hidden px-4 py-20">

      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-indigo-100 rounded-full blur-3xl opacity-40 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-100 rounded-full blur-3xl opacity-30 translate-x-1/3 translate-y-1/3 pointer-events-none" />

      {/* Floating dots */}
      <FloatingDot style={{ top: "18%", left: "12%", width: 10, height: 10, animationDelay: "0s" }} />
      <FloatingDot style={{ top: "30%", right: "10%", width: 7, height: 7, animationDelay: "0.8s" }} />
      <FloatingDot style={{ bottom: "25%", left: "20%", width: 6, height: 6, animationDelay: "1.4s" }} />
      <FloatingDot style={{ bottom: "18%", right: "18%", width: 9, height: 9, animationDelay: "0.4s" }} />

      {/* Logo / Brand mark */}
      <div
        className={`flex items-center gap-2 mb-12 transition-all duration-700 ${
          hasMounted ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
        }`}
      >
        <div className="">
          <img src={logo} alt="Quzy" className="h-16 sm:h-16 md:h-32 w-auto" />
        </div>
      </div>

      {/* Ghost 404 number */}
      <div className="relative flex items-center justify-center mb-2 select-none">
        <span
          className={`text-[160px] sm:text-[200px] font-black text-gray-100 leading-none tracking-tighter transition-all duration-700 delay-100 ${
            hasMounted ? "opacity-100 scale-100" : "opacity-0 scale-95"
          }`}
          aria-hidden="true"
        >
          404
        </span>
        {/* Centered overlay text */}
        <div
          className={`absolute inset-0 flex items-center justify-center transition-all duration-700 delay-200 ${
            hasMounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-indigo-50 text-indigo-600 text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full border border-indigo-100 mb-3">
              <FaCompass size={11} />
              Lost in the void
            </div>
          </div>
        </div>
      </div>

      {/* Headline & subtext */}
      <div
        className={`text-center max-w-lg transition-all duration-700 delay-300 ${
          hasMounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-3 leading-tight">
          Oops! This page doesn't exist
        </h1>
        <p className="text-gray-500 text-base leading-relaxed">
          The quzy or page you were looking for may have been moved, deleted,
          or perhaps never existed. Let&apos;s get you back on track.
        </p>
      </div>

      {/* Search bar */}
      {/* <form
        onSubmit={handleSearch}
        className={`mt-8 w-full max-w-md transition-all duration-700 delay-[400ms] ${
          hasMounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="relative flex items-center">
          <FaSearch
            size={14}
            className="absolute left-4 text-gray-400 pointer-events-none"
          />
          <input
            ref={inputRef}
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Search quizzes, topics, subjects…"
            className="w-full pl-10 pr-32 py-3.5 rounded-2xl border border-gray-200 bg-white text-gray-800 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all placeholder:text-gray-400"
          />
          <button
            type="submit"
            className="absolute right-2 flex items-center gap-1.5 bg-gradient-to-r from-indigo-600 to-purple-500 hover:from-indigo-700 hover:to-purple-600 text-white text-sm font-semibold px-5 py-2 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md active:scale-95"
          >
            Search <FaArrowRight size={11} />
          </button>
        </div>
      </form> */}

      {/* Divider */}
      {/* <div
        className={`flex items-center gap-4 my-8 w-full max-w-md transition-all duration-700 delay-500 ${
          hasMounted ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="flex-1 h-px bg-gray-200" />
        <span className="text-xs text-gray-400 font-medium tracking-wide uppercase">
          Or go to
        </span>
        <div className="flex-1 h-px bg-gray-200" />
      </div> */}

      {/* Quick links chips */}
      {/* <div
        className={`flex flex-wrap justify-center gap-2 max-w-md transition-all duration-700 delay-[550ms] ${
          hasMounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        {quickLinks.map((link, i) => (
          <a
            key={i}
            href={link.path}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-gray-200 bg-white text-sm text-gray-600 hover:border-indigo-300 hover:text-indigo-600 hover:bg-indigo-50 transition-all duration-200 shadow-sm hover:shadow-md active:scale-95"
            style={{ transitionDelay: `${i * 60}ms` }}
          >
            {link.label}
          </a>
        ))}
      </div> */}

      {/* Back home CTA */}
      <div
        className={`mt-10 transition-all duration-700 delay-700 ${
          hasMounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        <a
          href="/"
          className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-indigo-600 transition-colors duration-200 group"
        >
          <FaHome
            size={13}
            className="group-hover:-translate-x-0.5 transition-transform duration-200"
          />
          Back to homepage
        </a>
      </div>
    </section>
  );
}